export const freightReason = {
    DEFAULT: 'DEFAULT',
    SVOSJ: 'FRAM',
    SUBSCRIPTION: 'SUBSCRIPTION',
    TOTAL_OVER_MAX_AMOUNT: 'TOTAL_OVER_MAX_AMOUNT',
    NOT_ENABLED: 'NOT_ENABLED',
    ORDER_TOTAL_ZERO: 'ORDER_TOTAL_ZERO',
}
